<template>
    <div>
        
        <div v-if="loading"><i class="fa fa-lg fa-spin fa-spinner"></i> Tarkistetaan noutopisteitä...</div>
        <div v-else-if="!data.length">
            
        </div>
        <div v-else class="form-group">
            <div class="page-header"><h2>Valitse noutopiste</h2></div>
            <pickup-location v-for="item in data" :key="item.id" :pristine-item="item"></pickup-location>
        </div>
    </div>
</template>

<script>

import PickupLocation from "components/pickup-locations/item.vue"

export default {
    name: "PickupLocations",
    components: { PickupLocation },
    data() {
        return {
            loading: false,
            data: [],
        }
    },
    methods: {
        fetchData() {
            let url = "api/v1/order/cart/pickup_locations"
            this.loading = true
            this.$http.get(url).then(
                (response) => response.json(),
                (errorResponse) => errorResponse.json()
            ).then(this.handleResponse)
            .catch(function(e) {
                console.log(e)
            }).finally(function() {
                this.loading = false
            })
        },
        handleResponse(data) {
            if (!data.error) {
                this.data = data
            }
        },
    },
    created() {
        this.fetchData()
        // Kun tilaustiedot muuttuvat palvelimella, päivitetään noutopisteet
        EventBus.addEventListener("order.update", this.fetchData)
    },
}

</script>


// WEBPACK FOOTER //
// list.vue?a3c8477a